<script lang="ts">
    export let text: string = "";
    export let progressPercent: number = 0;
</script>

<div class="load-holder">
    
    <dic class="progressText">
        {text} {Math.floor(progressPercent * 100)}%
    </dic>
    <!-- <div class="loader" />-->
</div>

<style>
    .loader {
        border: 16px solid #f3f3f3;
        border-radius: 50%;
        border-top: 16px solid #ff3e00;
        width: 80px;
        height: 80px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    .progressText {
        font-size: large;
        font-weight: bold;
        font-family: "Courier New", Courier, monospace;
    }
    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .load-holder {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>
